export default "__VITE_ASSET__CB1ot9SL__"